import { Component, OnInit,Inject } from '@angular/core';
import { FormGroup,Validators,FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { ClipBoardService } from 'src/app/services/clipboard.service';
@Component({
  selector: 'app-project-all-status-modal',
  templateUrl: './project-all-status-modal.component.html',
  styleUrls: ['./project-all-status-modal.component.scss']
})
export class ProjectAllStatusModalComponent implements OnInit {
projectsDetails:any;
whatsappValue:any
valueChanged = sessionStorage.setItem('valueChanged','false');
userForm: FormGroup;
qualifiedHours : any;
qualifiedStatus:any;
disabledProjectStatus:any;
authToken = localStorage.getItem('token');
qualified:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    private serverService:ServerService,
    private fb:FormBuilder,
    private clipBoardService:ClipBoardService,

    private dialogRef: MatDialogRef<ProjectAllStatusModalComponent>,
  ) { 
    this.projectsDetails = data;
    this.disabledProjectStatus = this.projectsDetails.disabled ;
  }

  
    ngOnInit() {
      this.whatsappValue = this.projectsDetails.whatsapp_enabled;
      // console.log(this.projectsDetails)
      
      this.qualified = this.projectsDetails.qualified;
      this.qualifiedStatus = this.projectsDetails.qualified;
      this.qualifiedHours = this.projectsDetails.lead_expiry;
      if(this.projectsDetails.whats_app_profile == null)
          this.userForm = this.fb.group({
              name: [null, Validators.required],
              budget: [null, Validators.required],
              location: [null, Validators.required],
              possession: [''],
              inventory: ['']
          });
          else{
           
              this.userForm = this.fb.group({
                  name: [this.projectsDetails.whats_app_profile.name, Validators.required],
                  budget: [this.projectsDetails.whats_app_profile.budget, Validators.required],
                  location: [this.projectsDetails.whats_app_profile.location, Validators.required],
                  possession: [this.projectsDetails.whats_app_profile.possession],
                  inventory: [this.projectsDetails.whats_app_profile.inventory]
              });
          }
          
      
  
    // console.log(this.projectsDetails)
    // console.log(this.data);
  }
  close() {
    this.dialogRef.close();
}
// updateStatus(){
//   console.log("hi")
// }
approvedProject(element) {
  // this.statusSpinner = true
  let body = {
    "id": element.id,
    "approved": !element.approved
  }
  // console.log(body)
  this.serverService.approvedProject(body, this.authToken).subscribe(
    data => {
      if (data.disable) {
        this.clipBoardService.showMessgeInText("Project Succesfully Disapprove", "success-snackbar")
      } else {
        this.clipBoardService.showMessgeInText("Project Succesfully Approved", "success-snackbar")
      }
      sessionStorage.setItem('valueChanged','true');
      this.dialogRef.close();
      // this.statusSpinner = false
    },
    err => {
      // this.statusSpinner = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
  )
}
autoVerified(element) {
  // console.log(element)
  // this.autoVerification = event.checked;
  // console.log(this.autoVerification);
  let body = {
      "auto_verify": !element.auto_verify,
      "project_id":element.id

  }
  this.serverService.updateAutoVerified(element.id, body, this.authToken).subscribe(
      data => {
        sessionStorage.setItem('valueChanged','true');
          this.clipBoardService.showMessgeInText("Auto Verified Updated Succesfully", "success-snackbar")
          // this.btnStatus = true   this.dialogRef.close();
          this.dialogRef.close();
      },
      err => {

          this.clipBoardService.checkServerError(err, localStorage.getItem("token"))
      }
  )
}
recordingAccessToClientChanged(element) {
  // this.isRecordingAccessToClient = event.checked;
  let body = {
      "recording_access_to_client": !element.recording_access_to_client,
      "project_id": element.id,
  }
  this.serverService.recordingAccessToClient(body, this.authToken).subscribe(
      data => {
          this.clipBoardService.showMessgeInText("Recording Access To Client Updated Succesfully", "success-snackbar")
          // this.btnStatus = true
          sessionStorage.setItem('valueChanged','true');
          this.dialogRef.close();
      },
      err => {
          // this.isRecordingAccessToClient = !this.isRecordingAccessToClient
          this.clipBoardService.checkServerError(err, this.authToken)
      }
  )
}
statusChangedTat(element) {
 
  let body = {
      "is_status_changed_after_tat": !element.is_status_changed_after_tat,
      "project_id": element.id,
  }
  this.serverService.statusChangedAfterTat(body, this.authToken).subscribe(
      data => {
          this.clipBoardService.showMessgeInText("Status Changed After Tat Updated Succesfully", "success-snackbar")
          sessionStorage.setItem('valueChanged','true');
          this.dialogRef.close();
      },
      err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      }
  )
}


autoEmailNotify(element) {
  
  let body = {
      "notify_user_on_form_submit": !element.notify_user_on_form_submit
  }
  this.serverService.autoEmailNotify(element.id, body, this.authToken).subscribe(
      data => {
          this.clipBoardService.showMessgeInText("Email Notifcation Updated Succesfully", "success-snackbar")
          sessionStorage.setItem('valueChanged','true');
          this.dialogRef.close();
      },
      err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      }
  )
}
removeNegativeStatus(element) {
 
  let body = {
      "remove_negative": !element.remove_negative,
      "project_id": element.id,
  }
  this.serverService.removeNegativeStatus(body, this.authToken).subscribe(
      data => {
          this.clipBoardService.showMessgeInText("Remove Negative Status Updated Succesfully", "success-snackbar")
          sessionStorage.setItem('valueChanged','true');
          this.dialogRef.close();
      },
      err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      }
  )
}
telephonyChanged(element) {

  let body = {
      "telephony": !element.telephony,
      "project_id": element.id,
  }
  this.serverService.telephonyCHange(body, this.authToken).subscribe(
      data => {
       
          this.clipBoardService.showMessgeInText("Telephone Status Updated Succesfully", "success-snackbar")
          sessionStorage.setItem('valueChanged','true');
          this.dialogRef.close();
      },
      err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      }
  )
}
whatsappStatusChange(element, event) {
  if(this.projectsDetails.whatsapp_enabled){
    sessionStorage.setItem('valueChanged','true');
  }
  // console.log(event.checked)
  // this.statusSpinner = true
  this.whatsappValue  = event.checked;
  // console.log(this.whatsappValue)
  // let body = {
  //   "whatsapp_enabled": !element.whatsapp_enabled
  // }
  // element.whatsapp_enabled = body["whatsapp_enabled"]
  // this.serverService.updateProject(element, body, this.authToken).subscribe(
  //   data => {
  //     if (data.whatsapp_enabled) {
  //       this.clipBoardService.showMessgeInText("Whatsapp Enabled Succesfully", "success-snackbar")
  //     } else {
  //       this.clipBoardService.showMessgeInText("Whatsapp Disabled Succesfully", "success-snackbar")
  //     }
  //     sessionStorage.setItem('valueChanged','true');
  //     // this.statusSpinner = false
  //   },
  //   err => {
  //     // this.statusSpinner = false
  //     this.clipBoardService.checkServerError(err, this.authToken)
  //   }
  // )
}
save() {
  // this.btnStatus = true
  let body = {
      project_id: this.projectsDetails.id,
      name: this.userForm.value.name,
      budget: this.userForm.value.budget,
      location: this.userForm.value.location,
      possession: this.userForm.value.possession,
      inventory: this.userForm.value.inventory
  }
  let body1 = {
    "whatsapp_enabled": this.whatsappValue
  }
  this.projectsDetails.whatsapp_enabled = body1["whatsapp_enabled"]
  this.serverService.updateProject(this.projectsDetails, body1, this.authToken).subscribe(
    data => {
      if (data.whatsapp_enabled) {
        this.clipBoardService.showMessgeInText("Whatsapp Enabled Succesfully", "success-snackbar")
      } else {
        this.clipBoardService.showMessgeInText("Whatsapp Disabled Succesfully", "success-snackbar")
      }
      sessionStorage.setItem('valueChanged','true');
      if (this.projectsDetails.whats_app_profile == null) {
        // console.log("hi")
        // console.log(body);
       
        this.serverService.createWhatsappProfile(body, this.authToken).subscribe(
            data => {
              
            //     this.snackBar.open("Profile Created Succesfully", '', {
            //         duration: 1000,
            //         verticalPosition: 'top',
            //         horizontalPosition: 'end',
            //         panelClass: 'blue-snackbar'
            //     })
                // this.btnStatus = false
                this.dialogRef.close(data)
                this.clipBoardService.showMessgeInText("Whatsapp Profile Created Succesfully", "success-snackbar");
            },
            err => {
                // this.btnStatus = false
                this.clipBoardService.checkServerError(err, this.authToken)
            })
        
    } else {
      // console.log(this.projectsDetails)
        this.serverService.updateWhatsappProfile(this.projectsDetails.whats_app_profile.id, body, this.authToken).subscribe(
            data => {
                // this.snackBar.open("Profile Updated Succesfully", '', {
                //     duration: 1000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'end',
                //     panelClass: 'blue-snackbar'
                // })
                this.clipBoardService.showMessgeInText("Whatsapp Profile Updated Succesfully", "success-snackbar");
                // this.btnStatus = false
                this.dialogRef.close(data)
            },
            err => {
                // this.btnStatus = false
                this.clipBoardService.checkServerError(err, this.authToken)
            }
        )
    }
      // this.statusSpinner = false
    },
    err => {
      // this.statusSpinner = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
  )
  
}
saveQualifiedLead() {
  // this.btnStatus = true
  let body = {
      "qualified": this.qualifiedStatus,
  }
  // console.log(this.qualified)
  if (this.qualifiedStatus) {
      body["lead_expiry"] = this.qualifiedHours
  }
  // body["lead_expiry"] = this.qualifiedHours;
  this.serverService.updateQualified(this.projectsDetails.id, body, this.authToken).subscribe(
      data => {
          this.clipBoardService.showMessgeInText("Updated Successfully", "success-snackbar")
          this.dialogRef.close("Updated Successfully");
          // this.btnStatus = false
      },
      err => {
          // this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken);
      }
  )
}
projectQualifiedStatus(element:any,event:any){
  // console.log(event);
  this.qualifiedStatus = event.checked

}
disableProject(element, event) {
  // this.statusSpinner = true
  // console.log(event.checked)
  let body = {
    "disable": !event.checked
  }
  
  this.disabledProjectStatus = body["disable"];
  element.disable = this.disabledProjectStatus;
  this.serverService.updateProject(element, body, this.authToken).subscribe(
    data => {
      if (data.disable) {
        this.clipBoardService.showMessgeInText("Project Disabled Succesfully", "success-snackbar")
        // this.dialogRef.close(data)
      } else {
        this.clipBoardService.showMessgeInText("Project Enabled Succesfully", "success-snackbar")
        // this.dialogRef.close(data)
      }
      this.dialogRef.close(data)
      // this.statusSpinner = false
    },
    err => {
      // this.statusSpinner = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
  )
}
smsEnabled(element){
  // console.log(element)
  let body = {
    "client_sms_enabled": !element.client_sms_enabled,
    "id": element.id,
}
  this.serverService.updateSmsConfiguration(body,this.authToken).subscribe(
    data => {
      // console.log(data)
      if (data.client_sms_enabled) {
        this.clipBoardService.showMessgeInText("Sms Configuration Enabled Succesfully", "success-snackbar")
        // this.dialogRef.close(data)
      } else {
        this.clipBoardService.showMessgeInText("Sms Configuration Disabled Succesfully", "success-snackbar")
        // this.dialogRef.close(data)
      }
      this.dialogRef.close(data)
      // this.statusSpinner = false
    },
    err => {
      // this.statusSpinner = false
      this.clipBoardService.checkServerError(err, this.authToken)
    }
  )
  // console.log("hi")
}
}
